let analyticsCallback;

const consentHandler = (consentObject) => {
  handleAnalyticsConsentSaved(consentObject, analyticsCallback);
};

/**
 * Handles consent preference changes. If the Analytics category is consented the callback is executed, and the event listener is removed to prevent the callback from firing more than once.
 * @param {object} consentObject -  the Osano consent object
 * @param {function} callback - the callback function to execute when consent is given
 * @see https://docs.osano.com/developer-documentation-consent-javascript-api#event-listeners
 */
export const handleAnalyticsConsentSaved = (consentObject, callback) => {
  if (consentObject.ANALYTICS === "ACCEPT") {
    callback();
    window.Osano.cm.off("osano-cm-consent-saved", consentHandler);
  }
};

/**
 * Manages callback execution to ensure Analytics consent is granted. The callback is executed immediately if consent is currently granted, or execution is deferred by delegating to an event listener watching for changes in consent.
 * @param {function} callback function to execute on consent change
 * @see https://docs.osano.com/developer-documentation-consent-javascript-api#event-listeners
 */
export const handleAnalyticsConsent = (callback) => {
  if (window.Osano && window.Osano.cm.analytics) {
    callback();
  } else {
    analyticsCallback = callback;
    window.Osano &&
      window.Osano.cm.on("osano-cm-consent-saved", consentHandler);
  }
};
